import { Helmet } from 'react-helmet'
import { APP_NAME, APP_DESCRIPTION } from '../appVersion'
import { updates } from '../views/Version/Version'

const Seo = ({ title, desc }) => {
  return (
    <Helmet>
      <title>
        {title ? `${title} | ` : ''}
        {APP_NAME} {updates[0].version}
      </title>
      {title && <meta name='og:title' content={title} />}
      <meta name='og:description' content={desc || APP_DESCRIPTION} />
      <meta name='description' content={desc || APP_DESCRIPTION} />
    </Helmet>
  )
}

export default Seo
